import { getOfferTypeFromJsonQuery, getTermsValue, isSuburban } from '@/packages/JsonQuery';
import { EHouseMaterial } from '@/packages/api-models/common/json_query';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagHouseMaterialSchema } from '../types';

const TEXT_MAP: { [key in EHouseMaterial]: string | null } = {
  [EHouseMaterial.None]: null,
  [EHouseMaterial.Brick]: 'кирпичный',
  [EHouseMaterial.Monolith]: 'монолитный',
  [EHouseMaterial.Panel]: 'панельный',
  [EHouseMaterial.Block]: 'блочный',
  [EHouseMaterial.Wood]: 'деревянный',
  [EHouseMaterial.Stalin]: 'сталинский',
  [EHouseMaterial.Shield]: 'щитовой',
  [EHouseMaterial.BrickMonolith]: 'кирпично-монолитный',
  [EHouseMaterial.Wireframe]: 'каркасный',
  [EHouseMaterial.AerocreteBlock]: 'газобетонный блок',
  [EHouseMaterial.GasSilicateBlock]: 'газосиликатный блок',
  [EHouseMaterial.FoamConcreteBlock]: 'пенобетонный блок',
};

export const houseMaterial: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermsValue('house_material')(jsonQuery);
    if (!value) {
      return null;
    }

    const offerType = getOfferTypeFromJsonQuery(jsonQuery);
    const prefix = isSuburban(offerType) ? 'Материал дома' : 'Тип дома';

    const tagsGroup = value.reduce<TagHouseMaterialSchema[]>((acc, key) => {
      const text = TEXT_MAP[key];
      if (!text) {
        return acc;
      }

      acc.push({
        group: 'houseMaterial',
        text: `${prefix}: ${text}`,
        data: key,
      });

      return acc;
    }, []);

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagHouseMaterialSchema) {
    const currentValue = getTermsValue('house_material')(jsonQuery) || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setConstructionTypes',
      arguments: [nextValue],
    });
  },
};
